import {
  ICullOccludedContainersOptions,
  TSideViewSide,
  cullOccludedContainers,
} from "./cullOccludedContainers";
import { SmartPairedBayBlock, SmartUnpairedBayBlock } from "@tedivo/tedivo-bay-grid-pure";
import { getAllContainersPortSide, getAllContainersStbdSide } from "./getAllContainers";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

/**
 * The containers that can be seen from one side of the ship: all of them, minus the ones that
 * the rows nearer to the viewer cover completely. Partly visible containers are kept and ordered
 * from the farthest row to the nearest, so painter's order shows only their visible part.
 */
export function getSideContainers(
  side: TSideViewSide,
  options?: ICullOccludedContainersOptions,
): (smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock) => TGetContainersFilterOutput {
  return function getSideContainersFn(
    smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
  ): TGetContainersFilterOutput {
    const all =
      side === "port" ? getAllContainersPortSide(smartBay) : getAllContainersStbdSide(smartBay);

    return {
      ...all,
      containers: cullOccludedContainers(all.containers, side, options),
    };
  };
}
